module.exports = __webpack_public_path__ + "assets/img/vr3.c45c5d16.jpg";